export default "__VITE_ASSET__0315fc7a__"